module.exports = __webpack_public_path__ + "assets/img/check-mark.9bb34cbe.svg";